//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ConfirmDialog.vue",
  data: () => ({
    active: false,
    resolve: null,
    reject: null,
    message: null,
    confirmText: "",
    cancelText: ""
  }),
  methods: {
    show(message, confirmText, cancelText = 'Abbrechen' ) {
      this.message = message
      this.confirmText = confirmText
      this.cancelText = cancelText
      this.active = true
      return new Promise( (resolve, reject) =>{
        this.resolve = resolve
        this.reject = reject
      })
    },
    onConfirm () {
      console.log("Confirm")
      this.resolve("Resolved")
    }
  },
  computed: {
    title() {
      return `Delete "${ this.info.title }" ?`
    }
  }
}
